import React, { Component } from "react";
import "./style.css";
import "../../../../index.css";
import { post, get } from "../../../../utils/request";
class Reset extends Component {
  constructor(props) {
    super(props);
    this.state = {
      phone: "",
      code: "",
      onepassword: "",
      twopassword: "",
      error_visible: false,
      error_info: "",
      code_name: "获取验证码",
      yztime: 59,
      loading: false,
      // 图形验证码相关
      imgCode: "",
      imgCodeUrl: "",
      imgCodeVisible: false,
    };
  }
  render() {
    return (
      <div>
        <div className="reset_img">
          <img alt="" src={require("../../../../images/user/reset.png")}></img>
        </div>
        <div className="reset_box">
          <div className="reset_phone">
            <input
              type="text"
              onChange={this.handlePhoneChang}
              value={this.state.phone}
              placeholder="请输入手机号"
            ></input>
          </div>
          <div className="reset_code">
            <input
              type="text"
              onChange={this.handleCodeChang}
              value={this.state.code}
              className="fl"
              placeholder="短信验证码"
            ></input>
            <div
              onClick={() => this.requestSms()}
              style={
                this.state.loading === true
                  ? { backgroundColor: "#f1f1f1", color: "#5d5d5d" }
                  : { backgroundColor: "#ff5900" }
              }
              className="reset_code_btn fr"
            >
              {this.state.code_name}
            </div>
          </div>
          <div className="reset_onepassword">
            <input
              type="password"
              onChange={this.handleOnepasswordChang}
              value={this.state.onepassword}
              placeholder="请输入新密码 （6-18位）"
            ></input>
          </div>
          <div className="reset_twopassword">
            <input
              type="password"
              onChange={this.handleTwopasswordChang}
              value={this.state.twopassword}
              placeholder="请确认新密码 （6-18位）"
            ></input>
          </div>
          <div onClick={() => this.requestReset()} className="reset_btn">
            确认修改
          </div>
          <div
            style={
              this.state.error_visible === true
                ? { display: "block" }
                : { display: "none" }
            }
            className="reset_error"
          >
            <div className="reset_modal">
              <img
                alt=""
                src={require("../../../../images/user/notice.png")}
              ></img>
              <div className="reset_error_info">
                <p>{this.state.error_info}</p>
              </div>
              <div
                onClick={() => this.handleCloseModal()}
                className="reset_error_btn"
              >
                好 的
              </div>
            </div>
          </div>
        </div>
      {/* 图形验证码弹窗 */}
      <div
        style={
          this.state.imgCodeVisible === true
            ? { display: "block" }
            : { display: "none" }
        }
        className="reset_error"
      >
        <div className="reset_modal imgcode_modal">
          <div className="imgcode_title">请输入图形验证码</div>
          <div className="imgcode_row">
            <img
              alt="图形验证码"
              src={this.state.imgCodeUrl}
              onClick={this.refreshImgCode}
              className="imgcode_img"
            />
            <span className="imgcode_tip">点击图片刷新</span>
          </div>
          <div className="imgcode_input_row">
            <input
              type="text"
              value={this.state.imgCode}
              onChange={this.handleImgCodeChang}
              placeholder="请输入图片中的内容"
              className="imgcode_input"
              maxLength={4}
            />
          </div>
          <div className="imgcode_btns">
            <div
              onClick={this.handleCancelImgCode}
              className="imgcode_btn_cancel"
            >
              取消
            </div>
            <div
              onClick={this.handleConfirmImgCode}
              className="imgcode_btn_confirm"
            >
              确认
            </div>
          </div>
        </div>
      </div>
    </div>
    );
  }
  /**
   * 关闭通用的显示框
   */
  handleCloseModal = () => {
    this.setState({
      error_visible: false,
    });
    if (this.state.error_info === "密码重置成功") {
      window.location.href =
        window.location.protocol +
        "//" +
        window.location.host +
        "/?login_phone=" +
        this.state.phone;
    }
  };
  handlePhoneChang = (e) => {
    this.setState({
      phone: e.target.value,
    });
  };
  handleCodeChang = (e) => {
    this.setState({
      code: e.target.value,
    });
  };
  handleOnepasswordChang = (e) => {
    this.setState({
      onepassword: e.target.value,
    });
  };
  handleTwopasswordChang = (e) => {
    this.setState({
      twopassword: e.target.value,
    });
  };
  /**
   * 倒计时60s
   */
  count = () => {
    let { yztime } = this.state;
    let time;
    this._smsInterval = setInterval(() => {
      time = yztime--;
      this.setState(
        { yztime: time, code_name: time + "秒后重新获取", loading: true },
        () => {
          if (yztime <= -1) {
            clearInterval(this._smsInterval);
            this.setState({
              loading: false,
              yztime: 59,
              code_name: "获取验证码",
              code_disabled: false,
            });
          }
        }
      );
    }, 1000);
  };
  /**
   * 请求短信
   */
  requestSms = () => {
    if (this.state.phone === "") {
      this.setState({
        error_visible: true,
        error_info: "手机号不能为空",
      });
      return;
    }
    if (!(this.state.phone.length === 11 && this.state.phone[0] === "1")) {
      this.setState({
        error_visible: true,
        error_info: "手机号有误",
      });
      return;
    }
    if (this.state.yztime === 59) {
      // 先弹出图形验证码弹窗
      this.setState({
        imgCode: "",
        imgCodeUrl: "/public/v1/user/imgCode?t=" + new Date().getTime(),
        imgCodeVisible: true,
      });
    }
  };
  /**
   * 图形验证码输入变化
   */
  handleImgCodeChang = (e) => {
    this.setState({ imgCode: e.target.value });
  };
  /**
   * 刷新图形验证码
   */
  refreshImgCode = () => {
    this.setState({
      imgCodeUrl: "/public/v1/user/imgCode?t=" + new Date().getTime(),
      imgCode: "",
    });
  };
  /**
   * 取消图形验证码弹窗
   */
  handleCancelImgCode = () => {
    this.setState({ imgCodeVisible: false, imgCode: "" });
  };
  /**
   * 确认图形验证码，发起短信请求
   */
  handleConfirmImgCode = () => {
    if (this.state.imgCode === "") {
      this.setState({
        error_visible: true,
        error_info: "图形验证码不能为空",
        imgCodeVisible: false,
      });
      return;
    }
    let params = { phone: this.state.phone, type: 2, imgCode: this.state.imgCode };
    get("/public/v1/user/phone/" + params.phone).then((res) => {
      if (res.status === "success") {
        this.setState({
          error_visible: true,
          error_info: res.data.err_msg,
          phone: "",
          imgCodeVisible: false,
        });
      } else {
        this.setState({ imgCodeVisible: false });
        this.count();
        post("/public/v1/user/sms", params).then((res) => {
          if (res.status === "fail") {
            clearInterval(this._smsInterval);
            this.setState({
              loading: false,
              yztime: 59,
              code_name: "获取验证码",
              error_visible: true,
              error_info: res.data.err_msg,
            });
          }
        });
      }
    });
  };
  requestReset = () => {
    let params = { phone: "", code: "", type: 2, password: "" };
    params.phone = this.state.phone;
    params.code = this.state.code;
    params.password = this.state.onepassword;
    if (params.phone === "") {
      this.setState({
        error_visible: true,
        error_info: "手机号不能为空",
      });
      return;
    }
    if (!(this.state.phone.length === 11 && this.state.phone[0] === "1")) {
      this.setState({
        error_visible: true,
        error_info: "手机号有误",
      });
      return;
    }
    if (params.code === "") {
      this.setState({
        error_visible: true,
        error_info: "验证码不能为空",
        code: "",
      });
      return;
    }
    if (params.password === "") {
      this.setState({
        error_visible: true,
        error_info: "密码不能为空",
      });
      return;
    }
    if (params.password.length < 6 || params.password.length > 18) {
      this.setState({
        error_visible: true,
        error_info: "请输入新密码（6-18位）",
      });
      return;
    }
    if (this.state.onepassword !== this.state.twopassword) {
      this.setState({
        error_visible: true,
        error_info: "密码不一致",
      });
      return;
    }
    post("/public/v1/user/reset", params).then((res) => {
      if (res.status === "success") {
        this.setState({
          error_visible: true,
          error_info: res.data,
          code: "",
        });
      } else {
        this.setState({
          error_visible: true,
          error_info: res.data.err_msg,
          code: "",
        });
      }
    });
  };
}

export default Reset;



// WEBPACK FOOTER //
// ./src/containers/User/components/Reset/index.js